import React from 'react';
import { CheckIcon } from 'lucide-react';
import { checkoutUrl } from '../data/content';
import { bonuses, checkoutAssurances, pricing, systemStack } from '../data/bonuses';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
export function Pricing() {
  return <section id="offer" className="scroll-mt-20 bg-forest px-4 py-14 md:py-20" aria-labelledby="offer-title" data-id="element-149" data-mp="3nr347230a9mm">
      <div className="mx-auto max-w-2xl" data-id="element-150" data-mp="fbje2bxmt7bs">
        <div className="text-center" data-id="element-151" data-mp="fcm28c3kkvo0">
          <h2 id="offer-title" className="font-display text-2xl font-black uppercase leading-tight text-ivory md:text-4xl" data-id="element-152" data-mp="kanmv1gn931l">
            Get the Complete Stretching System 2026 <span className="text-gold" data-id="element-153" data-mp="6d7gtr29fbad">today</span>
          </h2>
          <p className="mt-6 text-xs font-extrabold uppercase tracking-[.18em] text-ivory/80" data-id="element-154" data-mp="abewsjowg8ki">
            Launch price ends in:
          </p>
          <div className="mt-3" data-id="element-155" data-mp="2r3q2f51x9ml7">
            <Countdown data-id="element-156" data-mp="2v3gsf6jmjyoo" />
          </div>
        </div>

        <article className="mt-8 rounded-3xl border-4 border-dashed border-gold bg-white p-6 shadow-2xl md:p-10" data-id="element-157" data-mp="2v0ukh5stnh5x">
          <div className="flex items-center justify-between gap-3" data-id="element-158" data-mp="2aohlzcr5gbb4">
            <p className="font-display text-base font-black uppercase text-charcoal md:text-lg" data-id="element-159" data-mp="2aqc8gvi2kbhb">
              Complete 6-volume system
            </p>
            <p className="shrink-0 text-right text-xs font-bold uppercase text-charcoal/60" data-id="element-160" data-mp="2km5v57pi5lct">
              Individual value:{' '}
              <s className="text-base font-black text-charcoal/60 decoration-red-600 decoration-2" data-id="element-161" data-mp="2yl5hg8pjlo5t">
                ${pricing.systemValue} USD
              </s>
            </p>
          </div>
          <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-162" data-mp="38b89a5kxgw2k">
            {systemStack.map(item => <li key={item} className="flex items-start gap-2 text-sm font-semibold text-charcoal" data-id="element-163" data-mp="33ehtzkgy64i7">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest" aria-hidden="true" data-id="element-164" data-mp="3hdpvwl4hvqq3" />
                {item}
              </li>)}
          </ul>

          <p className="mt-6 font-display text-sm font-black uppercase tracking-wider text-gold-ink" data-id="element-165" data-mp="2a0yxzhlbmld6">
            Plus 5 bonuses:
          </p>
          <ul className="mt-2 divide-y divide-charcoal/10" data-id="element-166" data-mp="2f01q61g7cx3q">
            {bonuses.map(bonus => <li key={bonus.number} className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-167" data-mp="2izkfd9f23ucd">
                <span className="font-semibold text-charcoal" data-id="element-168" data-mp="2nt5388mxr7xu">{bonus.name}</span>
                <span className="flex shrink-0 items-center gap-2" data-id="element-169" data-mp="2sq58wifvi8of">
                  <s className="font-bold text-charcoal/55 decoration-red-600 decoration-2" data-id="element-170" data-mp="2xpi3xqgwem23">${bonus.value} USD</s>
                  <span className="text-xs font-black uppercase text-forest" data-id="element-171" data-mp="32q5vqecyb6xd">Free today</span>
                </span>
              </li>)}
            <li className="flex items-center justify-between gap-3 py-2.5 text-sm" data-id="element-172" data-mp="36odch97f088k">
              <span className="font-display font-black uppercase text-charcoal" data-id="element-173" data-mp="18cwh685jsv89">Total bonus value</span>
              <s className="shrink-0 font-black text-charcoal/60 decoration-red-600 decoration-2" data-id="element-174" data-mp="1cerhb9bqt2kg">
                ${pricing.bonusValue} USD
              </s>
            </li>
          </ul>

          <div className="mt-4 flex items-center justify-between gap-4 rounded-xl bg-ivory px-4 py-3" data-id="element-175" data-mp="1014jxyqwlz0r">
            <span className="font-display text-sm font-black uppercase text-charcoal" data-id="element-176" data-mp="v3m8o1pez7pl">Total individual value</span>
            <s className="font-display text-xl font-black text-charcoal/70 decoration-red-600 decoration-[3px]" data-id="element-177" data-mp="qzxzjel4w428">
              ${pricing.totalValue} USD
            </s>
          </div>

          <div className="mt-8 text-center" data-id="element-178" data-mp="1itqf0gtzllka">
            <p className="text-[11px] font-black uppercase tracking-[.18em] text-forest md:text-xs" data-id="element-179" data-mp="1eqtycvo0bziz">
              Today's promotional price
            </p>
            <p className="mt-2 font-display text-6xl font-black leading-none text-charcoal md:text-8xl" data-id="element-180" data-mp="19uczb6f9s0r4">
              ${pricing.price} <span className="text-2xl md:text-4xl" data-id="element-181" data-mp="3uihmq2oygjq6">USD</span>
            </p>
            <p className="mt-3 font-display text-sm font-black uppercase tracking-wider text-forest" data-id="element-182" data-mp="3ukkkxa09hj5z">
              One-time payment
            </p>
            <p className="mt-2 inline-flex rounded-md bg-gold/20 px-3 py-1.5 text-xs font-extrabold uppercase text-gold-ink md:text-sm" data-id="element-183" data-mp="1r0rpk4log0nn">
              You save ${pricing.savings} USD
            </p>
            <p className="mt-3 text-xs font-black uppercase tracking-wide text-forest md:text-sm" data-id="element-184" data-mp="1h9x77bbjxl7h">
              All 5 professional bonuses included free today
            </p>
            <div className="mt-7" data-id="element-185" data-mp="29z409us8lilc">
              <Button href={checkoutUrl} size="lg" fullWidth subtext="Instant digital access" data-id="element-186" data-mp="29y2qdtmyj257">
                Get Complete Stretching System 2026
              </Button>
            </div>
            <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-2" data-id="element-187" data-mp="20xwdo9z32673">
              {checkoutAssurances.map(item => <li key={item} className="flex items-center gap-1.5 text-[11px] font-extrabold uppercase text-charcoal/70" data-id="element-188" data-mp="kj4l9x1xsyxs">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-forest" aria-hidden="true" data-id="element-189" data-mp="ph688t2hhiej" />
                  {item}
                </li>)}
            </ul>
          </div>
        </article>
      </div>
    </section>;
}